module.exports = __webpack_public_path__ + "img/60.f2b4316a.jpg";